<template>
  <div id="app">
    <sidebar v-if="isWebView" />
    <burgerMenu v-else />
    <router-view class="router-view" id="router-view" />
    <div class="cursor" id="cursor"></div>
  </div>
</template>

<script>
import sidebar from "./components/nav/sidebar.vue";
import burgerMenu from "./components/nav/burgerMenu.vue";
export default {
  name: "App",
  components: { sidebar, burgerMenu },
  data() {
    return {
      cursor: null,
      tabletBreakPoint: 768,
      mobileBreakPoint: 480,
    };
  },
  methods: {
    editCursor(e) {
      const { clientX: x, clientY: y } = e;
      this.cursor.style.left = x + "px";
      this.cursor.style.top = y + "px";
    },
    scrollPage() {
      var offSet = window.scrollY;
      var innerHeight = window.innerHeight;
      var scrollPosition = 0;
      if (offSet > 0) {
        scrollPosition = (1 + offSet / innerHeight - 0.3).toFixed(2);
      } else {
        scrollPosition = 0;
      }
      this.$store.dispatch("setScrollPosition", {
        scrollPosition: scrollPosition,
      });
    },
    onResize() {
      if (window.innerWidth < this.tabletBreakPoint) {
        if (window.innerWidth < this.mobileBreakPoint) {
          this.$store.dispatch("setCurrentView", {
            isMobileView: true,
            isTabletView: false,
            isWebView: false,
          });
        } else {
          this.$store.dispatch("setCurrentView", {
            isMobileView: false,
            isTabletView: true,
            isWebView: false,
          });
        }
      } else {
        this.$store.dispatch("setCurrentView", {
          isMobileView: false,
          isTabletView: false,
          isWebView: true,
        });
      }
      this.$store.dispatch("setWindowWidth", window.innerWidth);
    },
  },
  computed: {
    isWebView() {
      return this.$store.getters.getIsWebView;
    },
  },
  watch: {
    isWebView(newVal) {
      if (newVal) {
        this.cursor = document.querySelector(".cursor");
        window.addEventListener("mousemove", this.editCursor);
      } else {
        this.editCursor({ clientX: -100, clientY: -100 });
        window.removeEventListener("mousemove", this.editCursor);
      }
    },
  },
  mounted() {
    this.onResize();
    if (this.isWebView) {
      this.cursor = document.querySelector(".cursor");
      window.addEventListener("mousemove", this.editCursor);
    }
    window.addEventListener("scroll", this.scrollPage);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollPage);
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #e6e6e6;
  font-family: "Signika", sans-serif;
  font-size: 16px;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background-image: url("./assets/images/red-clouds.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
.router-view {
  background-color: #161616;
  width: Calc(100vw - 120px);
  margin-left: auto;
  margin-right: 0;
  @media only screen and (max-width: 768px) {
    width: 100vw;
    margin-left: 0;
  }
}
</style>
